import React from 'react';
import './AboutHero.css';

const AboutHero = () => {
    return (
        <section className="about-hero">
            <div className="about-hero-container">
                <div className="about-hero-content">
                    <h1 className="about-hero-title">
                        <div style={{ marginBottom: '23px' }}>Driven by Integrity.</div>
                        <span className="about-hero-title-highlight">Built on Expertise.</span>
                    </h1>
                    <p className="about-hero-description">
                        With years of experience in tax, accounting, and business advisory, PFGS is
                        committed to helping individuals and businesses navigate their financial journey with
                        confidence and clarity.
                    </p>
                    <div className="about-hero-buttons">
                        <a className="about-hero-btn about-hero-btn-primary" href='/accounting-services'>
                            Our Services
                        </a>
                        <a className="about-hero-btn about-hero-btn-secondary" href='/contact'>
                            Request a Quote
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutHero;
